import { render } from "./AuthNav.vue?vue&type=template&id=2fbdc3a2&scoped=true"
import script from "./AuthNav.vue?vue&type=script&lang=js"
export * from "./AuthNav.vue?vue&type=script&lang=js"

import "./AuthNav.vue?vue&type=style&index=0&id=2fbdc3a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbdc3a2"]])

export default __exports__